module.exports = __webpack_public_path__ + "static/img/zjzd.0c0dc1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/zjzd.png
// module id = wwxN
// module chunks = 4